import React, { useContext, useEffect, useRef, useState } from "react";
import { Input, Tag, theme } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { TweenOneGroup } from "rc-tween-one";
import { context } from "../../context/context";

const ModalTags = ({ section }) => {
    const { token } = theme.useToken();
    const {
        setCityTag,
        cityTag,
        placeTag,
        setPlaceTag,
        placeFormTag,
        setPlaceFormTag,
        linkestanTags,
        setLinkestanTags,
        newsTags,
        setNewsTags,
        eventTags,
        setEventTags,
        travelTags,
        setTravelTags,
        discountTags,
        setDiscountTags,
        galleryTags,
        setGalleryTags,
        adTags,
        setAdTags,
    } = useContext(context);
    const [inputVisible, setInputVisible] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const inputRef = useRef(null);
    useEffect(() => {
        if (inputVisible) {
            inputRef.current?.focus();
        }
    }, [inputVisible]);
    const handleClose = (removedTag) => {
        const newTags =
            section === "geo"
                ? cityTag.filter((tag) => tag !== removedTag)
                : section === "placeCategories"
                ? placeTag.filter((tag) => tag !== removedTag)
                : section === "addPlace"
                ? placeFormTag.filter((tag) => tag !== removedTag)
                : section === "linkestan"
                ? linkestanTags.filter((tag) => tag !== removedTag)
                : section === "news"
                ? newsTags.filter((tag) => tag !== removedTag)
                : section === "events"
                ? eventTags.filter((tag) => tag !== removedTag)
                : section === "travel"
                ? travelTags.filter((tag) => tag !== removedTag)
                : section === "discount"
                ? discountTags.filter((tag) => tag !== removedTag)
                : section === "gallery"
                ? galleryTags.filter((tag) => tag !== removedTag)
                : section === "ads"
                ? adTags.filter((tag) => tag !== removedTag)
                : null;
        if (section === "geo") setCityTag(newTags);
        else if (section === "placeCategories") setPlaceTag(newTags);
        else if (section === "addPlace") setPlaceFormTag(newTags);
        else if (section === "linkestan") setLinkestanTags(newTags);
        else if (section === "news") setNewsTags(newTags);
        else if (section === "events") setEventTags(newTags);
        else if (section === "travel") setTravelTags(newTags);
        else if (section === "discount") setDiscountTags(newTags);
        else if (section === "gallery") setGalleryTags(newTags);
        else if (section === "ads") setAdTags(newTags);
    };
    const showInput = () => {
        setInputVisible(true);
    };
    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    };
    const handleInputConfirm = () => {
        if (
            inputValue &&
            cityTag.indexOf(inputValue) === -1 &&
            section === "geo"
        ) {
            setCityTag([...cityTag, inputValue]);
        } else if (
            inputValue &&
            placeTag.indexOf(inputValue) === -1 &&
            section === "placeCategories"
        ) {
            setPlaceTag([...placeTag, inputValue]);
        } else if (
            inputValue &&
            placeFormTag.indexOf(inputValue) === -1 &&
            section === "addPlace"
        ) {
            setPlaceFormTag([...placeFormTag, inputValue]);
        } else if (
            inputValue &&
            linkestanTags.indexOf(inputValue) === -1 &&
            section === "linkestan"
        ) {
            setLinkestanTags([...linkestanTags, inputValue]);
        } else if (
            inputValue &&
            newsTags.indexOf(inputValue) === -1 &&
            section === "news"
        ) {
            setNewsTags([...newsTags, inputValue]);
        } else if (
            inputValue &&
            eventTags.indexOf(inputValue) === -1 &&
            section === "events"
        ) {
            setEventTags([...eventTags, inputValue]);
        } else if (
            inputValue &&
            travelTags.indexOf(inputValue) === -1 &&
            section === "travel"
        ) {
            setTravelTags([...travelTags, inputValue]);
        } else if (
            inputValue &&
            galleryTags.indexOf(inputValue) === -1 &&
            section === "gallery"
        ) {
            setGalleryTags([...galleryTags, inputValue]);
        } else if (
            inputValue &&
            travelTags.indexOf(inputValue) === -1 &&
            section === "discount"
        ) {
            setDiscountTags([...discountTags, inputValue]);
        } else if (
            inputValue &&
            adTags.indexOf(inputValue) === -1 &&
            section === "ads"
        ) {
            setAdTags([...adTags, inputValue]);
        }
        setInputVisible(false);
        setInputValue("");
    };
    const tagPlusStyle = {
        background: token.colorBgContainer,
        borderStyle: "dashed",
    };
    return (
        <div
            style={{
                padding: "10px 55px 10px 0",
                borderBottom: "1px solid silver",
            }}
        >
            <div
                style={{
                    marginBottom: 16,
                }}
            >
                <TweenOneGroup
                    enter={{
                        scale: 0.8,
                        opacity: 0,
                        type: "from",
                        duration: 100,
                    }}
                    onEnd={(e) => {
                        if (e.type === "appear" || e.type === "enter") {
                            e.target.style = "display: inline-block";
                        }
                    }}
                    leave={{
                        opacity: 0,
                        width: 0,
                        scale: 0,
                        duration: 200,
                    }}
                    appear={false}
                >
                    {section === "geo"
                        ? cityTag.map((tag, index) => {
                              return (
                                  <span
                                      style={{
                                          display: "inline-block",
                                      }}
                                  >
                                      <Tag
                                          closable
                                          onClose={(e) => {
                                              e.preventDefault();
                                              handleClose(tag);
                                          }}
                                      >
                                          {tag}
                                      </Tag>
                                  </span>
                              );
                          })
                        : section === "placeCategories"
                        ? placeTag.map((tag, index) => {
                              return (
                                  <span
                                      style={{
                                          display: "inline-block",
                                      }}
                                  >
                                      <Tag
                                          closable
                                          onClose={(e) => {
                                              e.preventDefault();
                                              handleClose(tag);
                                          }}
                                      >
                                          {tag}
                                      </Tag>
                                  </span>
                              );
                          })
                        : section === "addPlace"
                        ? placeFormTag.map((tag, index) => {
                              return (
                                  <span
                                      style={{
                                          display: "inline-block",
                                      }}
                                  >
                                      <Tag
                                          closable
                                          onClose={(e) => {
                                              e.preventDefault();
                                              handleClose(tag);
                                          }}
                                      >
                                          {tag}
                                      </Tag>
                                  </span>
                              );
                          })
                        : section === "linkestan"
                        ? linkestanTags.map((tag, index) => {
                              return (
                                  <span
                                      style={{
                                          display: "inline-block",
                                      }}
                                  >
                                      <Tag
                                          closable
                                          onClose={(e) => {
                                              e.preventDefault();
                                              handleClose(tag);
                                          }}
                                      >
                                          {tag}
                                      </Tag>
                                  </span>
                              );
                          })
                        : section === "news"
                        ? newsTags.map((tag, index) => {
                              return (
                                  <span
                                      style={{
                                          display: "inline-block",
                                      }}
                                  >
                                      <Tag
                                          closable
                                          onClose={(e) => {
                                              e.preventDefault();
                                              handleClose(tag);
                                          }}
                                      >
                                          {tag}
                                      </Tag>
                                  </span>
                              );
                          })
                        : section === "events"
                        ? eventTags.map((tag, index) => {
                              return (
                                  <span
                                      style={{
                                          display: "inline-block",
                                      }}
                                  >
                                      <Tag
                                          closable
                                          onClose={(e) => {
                                              e.preventDefault();
                                              handleClose(tag);
                                          }}
                                      >
                                          {tag}
                                      </Tag>
                                  </span>
                              );
                          })
                        : section === "travel"
                        ? travelTags.map((tag, index) => {
                              return (
                                  <span
                                      style={{
                                          display: "inline-block",
                                      }}
                                  >
                                      <Tag
                                          closable
                                          onClose={(e) => {
                                              e.preventDefault();
                                              handleClose(tag);
                                          }}
                                      >
                                          {tag}
                                      </Tag>
                                  </span>
                              );
                          })
                        : section === "discount"
                        ? discountTags.map((tag, index) => {
                              return (
                                  <span
                                      style={{
                                          display: "inline-block",
                                      }}
                                  >
                                      <Tag
                                          closable
                                          onClose={(e) => {
                                              e.preventDefault();
                                              handleClose(tag);
                                          }}
                                      >
                                          {tag}
                                      </Tag>
                                  </span>
                              );
                          })
                        : section === "gallery"
                        ? galleryTags.map((tag, index) => {
                              return (
                                  <span
                                      style={{
                                          display: "inline-block",
                                      }}
                                  >
                                      <Tag
                                          closable
                                          onClose={(e) => {
                                              e.preventDefault();
                                              handleClose(tag);
                                          }}
                                      >
                                          {tag}
                                      </Tag>
                                  </span>
                              );
                          })
                        : section === "ads"
                        ? adTags.map((tag, index) => {
                              return (
                                  <span
                                      style={{
                                          display: "inline-block",
                                      }}
                                  >
                                      <Tag
                                          closable
                                          onClose={(e) => {
                                              e.preventDefault();
                                              handleClose(tag);
                                          }}
                                      >
                                          {tag}
                                      </Tag>
                                  </span>
                              );
                          })
                        : null}
                </TweenOneGroup>
            </div>
            {inputVisible ? (
                <Input
                    ref={inputRef}
                    type="text"
                    size="small"
                    style={{
                        width: 78,
                    }}
                    value={inputValue}
                    onChange={handleInputChange}
                    onBlur={handleInputConfirm}
                    onPressEnter={handleInputConfirm}
                />
            ) : (
                <Tag onClick={showInput} style={tagPlusStyle}>
                    <PlusOutlined /> اضافه کردن تگ جدید
                </Tag>
            )}
        </div>
    );
};

export default ModalTags;
